export default __webpack_public_path__ + "static/media/search.c38b1e1a.svg";